var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FullStorySampleMode } from "../types/config";
import * as FullStory from "@fullstory/browser";
import { getDomainUserId, hashString } from "../util";
var _trackers = {};
export var FullStoryPlugin = function () {
    return {
        activateBrowserPlugin: function (tracker) {
            _trackers[tracker.id] = tracker;
        },
    };
};
export var staticContextData = function (opts) {
    return function (domainUserId) { return __awaiter(void 0, void 0, void 0, function () {
        var hash, userBucket, sampleRate, samplingEnabled;
        return __generator(this, function (_a) {
            if (!domainUserId) {
                return [2, Promise.reject("Missing domainUserId")];
            }
            if (!opts.fsLibOptions) {
                return [2, Promise.reject("Missing FullStory library options")];
            }
            hash = Math.abs(hashString(domainUserId));
            userBucket = hash % 100;
            sampleRate = opts.staticSampleSize || 0;
            samplingEnabled = userBucket <= sampleRate;
            return [2, Promise.resolve({
                    org_id: opts.fsLibOptions.orgId,
                    sample_method: "static",
                    sample_rate: sampleRate,
                    sampling_enabled: samplingEnabled,
                    user_bucket: userBucket,
                })];
        });
    }); };
};
export var dynamicContextData = function (opts) {
    return function (domainUserId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log(opts);
            console.log(domainUserId);
            return [2, Promise.reject("Dynamic sampling not currently supported")];
        });
    }); };
};
var initialiseFullStory = function (opts, tracker) {
    if (opts.samplingMethod == FullStorySampleMode.Static) {
        if (!opts.staticSampleSize) {
            throw new Error("staticSampleSize is required for static sampling");
        }
        else {
            if (opts.staticSampleSize < 0 || opts.staticSampleSize > 100) {
                throw new Error("staticSampleSize is must be between 0 and 100");
            }
        }
    }
    var duid = getDomainUserId();
    var theFunc = opts.samplingMethod == FullStorySampleMode.Static
        ? staticContextData(opts)
        : dynamicContextData(opts);
    Promise.all([theFunc(duid)])
        .then(function (result) {
        var context = result[0];
        if (context.sampling_enabled && opts.fsLibOptions) {
            FullStory.init(opts.fsLibOptions);
            context.session_url = FullStory.getCurrentSessionURL() || "";
        }
        _trackers[tracker].core.addGlobalContexts([
            {
                schema: "iglu:co.zip.common/fullstory_context/jsonschema/1-0-0",
                data: context,
            },
        ]);
    })
        .catch(function (e) { return console.log("initialiseFullStory failed: " + e); });
};
export var identifyFullStoryUser = function (userId, properties) {
    FullStory.identify(userId, properties);
};
export var enableFullStory = function (opts, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    trackers.forEach(function (id) {
        if (_trackers[id]) {
            if (_trackers[id].sharedState.hasLoaded) {
                initialiseFullStory(opts, id);
            }
            else {
                _trackers[id].sharedState.registeredOnLoadHandlers.unshift(function () {
                    initialiseFullStory(opts, id);
                });
            }
        }
    });
};
